import { brandName } from "@/helpers/brandIcons";

// Şube bağlantıları. Anahtar (Branch.links[].icon) kullanıcının paneldeki seçtiği EMOJİ, değer ise
// tam adres. Eskiden anahtar sabit bir tür listesiydi ('phone', 'instagram', …) ve href'i o
// üretiyordu — tel:, wa.me/, mailto:, profil adresleri. Emoji şema taşımadığı için o katman
// tamamen kalktı; adresin doğruluğu artık girildiği yerde, panelde sağlanıyor.

// Şeması olan adrese DOKUNMA, çıplak alan adına https:// ekle. `(?!\d)` port'u şema sanmayı
// engelliyor: `site.com:8080/x` şema değil.
const withProtocol = (value) =>
  /^[a-z][a-z0-9+.-]*:(?!\d)/i.test(value) ? value : `https://${value}`;

export const buildLinkHref = (icon, value) =>
  withProtocol((value ?? "").trim());

// Yeni sekmede AÇILMAMASI gereken şemalar. tel:/mailto: bir sayfa açmıyor, işletim sistemine
// devrediyor — `target="_blank"` geride boş bir pencere bırakıyor. Eskiden bu karar anahtara
// bakıyordu (`icon === 'phone'`); anahtar serbest emoji olunca tek güvenilir kaynak adresin
// kendisi kaldı.
export const opensInSameTab = (href) =>
  /^(tel:|mailto:|sms:)/i.test(href ?? "");

// Harita bağlantısı mı? İki yerde gerekiyor ve ikisinde de aynı cevabı vermesi şart: şube seçim
// kartındaki "Yol Tarifi" çipi bunu ARIYOR, menüdeki iletişim ikonları ise bunu DIŞLIYOR (harita
// zaten "Şubelerimiz" listesindeki her satırın kendi bağlantısı, iki kez görünmesin).
// Bir CEP numarasından WhatsApp adresi türetir; cep değilse null.
//
// Şube kartında telefon varsa WhatsApp da bekleniyor ve çoğu şubede ikisi aynı numara — ayrı bir
// bağlantı girmek gereksiz iş. Ama SABİT HATTA WhatsApp yok: `tel:+902161234567` için çip basmak
// tıklayınca "bu numara WhatsApp'ta kayıtlı değil" ekranına düşen ölü bir bağlantı demek. TR'de cep
// ülke kodundan sonra 5 ile başlıyor, sabit hatlar 2/3/4 ile.
//
// Kalan risk: cep numarası WhatsApp'ta kayıtlı olmayabilir. Panelde girilen AÇIK bir wa.me
// bağlantısı her zaman önce geliyor, yani kiracı istemiyorsa kendi adresini yazarak eziyor.
export const whatsappFromTel = (href) => {
  const match = /^tel:\+(905\d{9})$/.exec(href ?? "");

  return match ? `https://wa.me/${match[1]}` : null;
};

export const isMapsHref = (href) =>
  /(google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps|yandex\.[a-z.]+\/maps|maps\.apple\.com)/i.test(
    href ?? "",
  );

// Bu adres kiracının KENDİ sitesine mi gidiyor?
//
// Gidiyorsa menüde emoji yerine markanın kendi simgesi çıkıyor (BrandIcon → WebsiteIcon: kare
// amblem, yoksa yükleme görseli, yoksa logo). Kiracının kendi alan adı, jenerik bir 🌐'dan çok
// daha tanınır — ve panelde tür listesi kalktığı için "bu link web sitesi" bilgisini artık yalnızca
// adresin kendisi taşıyor.
//
// Eşleşme slug üzerinden, noktalar ve tireler atılarak: `noxuschocolate` → noxuschocolate.com,
// www.noxuschocolate.com, noxus-chocolate.com.
//
// noxussoft.com HARİÇ. Kendi alan adlarımız da kiracı slug'ını taşıyor (menü alt alanı, depolama)
// ama oradaki bağlantı kiracının sitesi değil, bizde duran bir dosya — katalog PDF'ine marka
// logosu basmak onu web sitesi sanmaya yol açardı.
const OWN_DOMAIN = /(^|\.)noxussoft\.com$/i;

export const isTenantSite = (href, slug) => {
  if (!slug || !/^https?:\/\//i.test(href ?? "")) {
    return false;
  }

  let host;

  try {
    host = new URL(href).hostname;
  } catch {
    return false;
  }

  if (OWN_DOMAIN.test(host)) {
    return false;
  }

  const flatten = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, "");

  return flatten(host).includes(flatten(slug));
};

export const linkLabel = (href, icon) => {
  const brand = brandName(icon);

  if (brand) {
    return brand.charAt(0).toUpperCase() + brand.slice(1);
  }
  if (/^tel:/i.test(href)) {
    return "telefon";
  }
  if (/^mailto:/i.test(href)) {
    return "e-posta";
  }
  if (/^sms:/i.test(href)) {
    return "SMS";
  }
  if (isMapsHref(href)) {
    return "harita";
  }

  try {
    return new URL(href).hostname.replace(/^www\./, "");
  } catch {
    return href;
  }
};
